import { render, staticRenderFns } from "./InputColorPicker.vue?vue&type=template&id=56122375&scoped=true&"
import script from "./InputColorPicker.vue?vue&type=script&lang=js&"
export * from "./InputColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./InputColorPicker.vue?vue&type=style&index=0&id=56122375&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56122375",
  null
  
)

export default component.exports